import { useQuery } from "@tanstack/react-query";

import { queryKeys } from "@/lib/query-keys";
import { cashReportService } from "@/services/cash-report";
import type { CashReportParams } from "@/services/cash-report";

export function useCashReport(params?: CashReportParams) {
  return useQuery({
    queryKey: queryKeys.cashReport.get(params as Record<string, unknown>),
    queryFn: () => cashReportService.get(params),
  });
}
